<div class="row c-form--d c-form__section">
  <div class="c-line__label ml-5 mr-5" i18n="@@common.add_free_parameters">Add Free Parameters</div>
  <button p500-ui-circled-button size="small" color="primary" type="button" (click)="addForm()">
    <p500-ui-icon name="plus"></p500-ui-icon>
  </button>
</div>
<ng-container *ngFor="let group of form.controls; index as i">
  <ng-container [formGroup]="group">
    <div class="c-form__section d-flex">
      <p500-ui-select-field formControlName="title" [data]="titleData" label="Title" i18n-label="@@common.title" class="flex-1">
      </p500-ui-select-field>
      <button
        p500-ui-circled-button
        size="small"
        type="button"
        color="warn"
        class="ml-10 mb-6 align-self-end"
        [transparent]="true"
        (click)="removeForm(i)"
      >
        <p500-ui-icon name="close"></p500-ui-icon>
      </button>
    </div>
    <div class="c-form__section">
      <p500-ui-select-field
        formControlName="keys"
        [data]="group.data"
        [multiple]="true"
        [clearable]="true"
        i18n-label="@@common.keys"
        label="Keys"
      >
      </p500-ui-select-field>
    </div>
  </ng-container>
  <div class="c-line--horizontal mt-22 mb-22" [hidden]="form.controls.length - 1 === i">
    <div class="c-line__line"></div>
  </div>
</ng-container>
